import { FuelPrice } from '../types/fuel-price.type';

export type FuelPriceStateModel = {
  formValue: FuelPrice;
  formValid: boolean;
  isLoading: boolean;
};

export class UpdateFormFuelPrice {
  static readonly type = '[Fuel Price] Update form fuel price';
  constructor(public payload: { value: FuelPrice; valid: boolean }) {}
}
